module.exports = __webpack_public_path__ + "media/kaczka_end_2.15188250.mp3";